import React, { useEffect, useState } from "react";
import axios from "axios";
import PageShell from "../components/PageShell";
import { SparklesIcon } from "../components/Icons";
import "./WishesBadges.css";

export default function WishesBadges() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      try {
        setLoading(true);
        const res = await axios.get("/api/wishes/badges", {
          withCredentials: true,
          params: { limit: 200 },
        });
        setItems(Array.isArray(res.data?.items) ? res.data.items : []);
      } catch (e) {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };
    run();
  }, []);

  return (
    <PageShell
      title="Wishes & Badges"
      subtitle="Recognition collected from live meeting appreciation moments."
    >
      <div className="wbRoot">
        {loading ? (
          <div className="card">
            <div className="card__body">Loading your recognitions...</div>
          </div>
        ) : items.length === 0 ? (
          <div className="card">
            <div className="card__body wbEmpty">
              <SparklesIcon className="icon" />
              <div>
                <div className="wbEmptyTitle">No wishes yet</div>
                <div className="wbEmptyHint">
                  When teammates appreciate you in live meetings, your wishes will appear here.
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="wbGrid">
            {items.map((it) => (
              <article key={it.id} className="card wbCard">
                <div className="card__body">
                  <div className="wbTop">
                    <span className="pill">Recognition</span>
                    <span className="wbDate">
                      {it.created_at ? new Date(it.created_at).toLocaleString() : ""}
                    </span>
                  </div>
                  <blockquote className="wbQuote">{it.quote}</blockquote>
                  <div className="wbSender">
                    Appreciated by: <strong>{it.sender_name || "Your teammate"}</strong>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </PageShell>
  );
}
